/**
 * When we're formatting text to be inserted into HTML built dynamically in JS, we'll
 * want to escape that text. Right now this is just for error messages where stack traces
 * can include text that is similar to HTML (for example "<GetTotalRequiredSpaceBytesAsync>").
 * @param rawText The raw text.
 * @returns The text with the HTML-specific characters escaped.
 */
export function escapeHtml(rawText: string): string {
  return rawText
    .replaceAll("&", '&amp;')
    .replaceAll("<", '&lt;')
    .replaceAll(">", '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}
